import { defineComponent as _defineComponent } from 'vue'
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AccountInfo from "@/components/transactions/AccountInfo.vue";
import { usePublicSalesStore} from "@/store/publicSales.store";
import { onBeforeMount, onMounted, ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import ApprovalModal from "@/components/buyTokens/modals/ApprovalModal.vue";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileTabs',
  setup(__props, { expose: __expose }) {
  __expose();

const showAddressAdd = ref(false);
const showApprovalModal = ref(false);
const router = useRouter();

onBeforeMount(() => {
  usePublicSalesStore().fetchTokenReservations();
});

onMounted(() =>{
  useUserServiceStore().getAccount(()=>{console.log(1);}, ()=>{console.log(2);});
  useUserServiceStore().getKycStatus();
});


function logOutAccount(){
  useUserServiceStore().logoutAccount();
  router.push('/buyTokens/signIn');
}
function showAddressAddModal(){
  showAddressAdd.value = true;
}
function showApprovalModalFunc(){
  showApprovalModal.value = true;
}
function hideApprovalModal(){
  showApprovalModal.value = false;
}

const __returned__ = { showAddressAdd, showApprovalModal, router, logOutAccount, showAddressAddModal, showApprovalModalFunc, hideApprovalModal, get TabView() { return TabView }, get TabPanel() { return TabPanel }, AccountInfo, get useUserServiceStore() { return useUserServiceStore }, ApprovalModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})